import { useEffect, useRef, useState } from 'react';

import { EVENT } from '@/utils/event';
import { innerHost } from '@/utils/host';

import { AudioQueuePlayer } from '../components/AudioQueuePlayer';
import useMindStorage, { EStorageKey } from './useMindStorage';

export interface IProps {
  voiceMute: boolean;
}
export default function useAudio(props: IProps) {
  const { voiceMute } = props;
  const [answerStopped] = useMindStorage(EStorageKey.ANSWER_STOPPED);
  const [messageId] = useMindStorage(EStorageKey.MESSAGE_ID);
  const [sessionId] = useMindStorage(EStorageKey.SESSION_ID);
  // 添加sessionIds列表
  const [sessionIds, setSessionIds] = useState<string[]>([]);

  const lastMessageId = useRef<string>('');

  const playerRef = useRef<AudioQueuePlayer | null>(null);

  if (!playerRef.current) {
    playerRef.current = new AudioQueuePlayer();
  }

  const getVoiceUrl = async (sid: string, msgId: string) => {
    const url = innerHost() + '/rest/audio/stream/player?sessionId=' + sid + '&messageId=' + msgId;

    return url;
  };

  const handleInitAudio = () => {
    playerRef.current?.clear();
  };

  const handlePlayAudio = async (sid: string, msgId: string) => {
    const audioUrl = await getVoiceUrl(sid, msgId);

    if (audioUrl) {
      // 不应该有延迟的 后端应该修复 虽然已修复 但防御性一手
      setTimeout(() => {
        playerRef.current?.add(audioUrl, sid, msgId);
      }, 200);
    }
  };

  useEffect(() => {
    if (sessionId && messageId) {
      if (sessionIds.includes(sessionId) && messageId !== lastMessageId.current) {
        handlePlayAudio(sessionId, messageId);
      }

      lastMessageId.current = messageId;
    }
  }, [sessionId, messageId, sessionIds]);

  useEffect(() => {
    playerRef.current?.setMute(voiceMute);
  }, [voiceMute]);

  useEffect(() => {
    handleInitAudio();

    const handleHasSendMessage = () => {
      handleInitAudio();
    };

    const handleAddSessionId = (e: Event) => {
      const event = e as CustomEvent;

      setSessionIds((prev) => [...prev, event.detail]);
    };

    const handleRemoveSessionId = (e: Event) => {
      const event = e as CustomEvent;

      setSessionIds((prev) => prev.filter((id) => id !== event.detail));
    };

    addEventListener(EVENT.HAS_SEND_MESSAGE, handleHasSendMessage);
    addEventListener(EVENT.ADD_VOICE_SESSION_ID, handleAddSessionId);
    addEventListener(EVENT.REMOVE_VOICE_SESSION_ID, handleRemoveSessionId);

    return () => {
      handleInitAudio();
      removeEventListener(EVENT.HAS_SEND_MESSAGE, handleHasSendMessage);
      removeEventListener(EVENT.ADD_VOICE_SESSION_ID, handleAddSessionId);
      removeEventListener(EVENT.REMOVE_VOICE_SESSION_ID, handleRemoveSessionId);
    };
  }, []);

  useEffect(() => {
    if (answerStopped) {
      handleInitAudio();
    }
  }, [answerStopped]);
}
